<template>
  <div class="bg-white pb-20">
    <div
      v-for="item in signedDocs"
      :key="item.id"
      class="border-t border-zt-dark-200"
      :class="{
        'documents--item__selected': item.id === docSelected
      }"
    >
      <zt-list-item
        class="outline-none items-center p-4"
        :class="{
          'documents--item__selected': item.id === docSelected,
          'documents--item': item.id !== docSelected
        }"
        :color="!item.locked ? 'success' : ''"
        @click="showDocument(item)"
      >
        <template>
          <div class="w-full leading-none text-left document--item-detail">
            <div class="text-zt-base truncate text-black mb-2">
              {{ item.carpeta_nombre + '-' + item.tipo_nombre }}
            </div>
            <div
              class="text-left text-zt-xs item--subtitle leading-none truncate mb-2"
            >
              {{ item.nombre ? item.nombre : item.periodo }}
            </div>
            <zt-chip
              v-if="getAccording(item).length > 0"
              square
              outline
              :class="getChipClass(item)"
            >
              {{ getAccording(item) }}
            </zt-chip>
          </div>
        </template>
      </zt-list-item>
    </div>
    <infinite-loading
      v-if="infiniteLoadingEnable"
      ref="infiniteLoading"
      spinner="spiral"
      @infinite="showMore"
    >
      <div class="noMoreResults" slot="no-more">
        {{ $t('message.documentComponent.noMoreResults') }}
      </div>
      <div class="noMoreResults" slot="no-results">
        {{ $t('message.documentComponent.noMoreResults') }}
      </div>
    </infinite-loading>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import InfiniteLoading from 'vue-infinite-loading'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'SignedDocs',
  components: {
    InfiniteLoading
  },
  props: ['signedDocs', 'docSelected', 'showDocument', 'windowWidth'],
  created() {
    if (!isEmpty(this.signedDocs) && this.windowWidth > 1024) {
      const firstDoc = this.signedDocs[0]
      return this.showDocument(firstDoc)
    }
  },
  computed: {
    ...mapGetters('documents', ['getSignedDocsInbox']),
    ...mapState('documents', ['signedLastId',]),
    isInboxDocumentActivated() {
      const actions = this.$store.state.actions
      return actions.some(action => action.id === '304')
    },
    infiniteLoadingEnable() {
      return (
        this.isInboxDocumentActivated &&
        this.signedLastId &&
        this.getSignedDocsInbox.length > 0
      )
    }
  },
  methods: {
    ...mapActions('documents', ['setDocumentsSigned']),
    async showMore() {
      await this.setDocumentsSigned({ append: true })
      await this.$nextTick()
      if (this.$store.state.documents.signedLastId) {
        this.$refs.infiniteLoading.stateChanger.reset()
      }
    },
    getAccording(item) {
      const signedStatus = {
        'FIRMADO CONFORME': 'message.documentComponent.details.confort',
        'FIRMADO DISCONFORME': 'message.documentComponent.details.notConfort',
        'NO REQUIERE FIRMA': 'message.documentComponent.details.notRequiredSign'
      }
      return this.$t(signedStatus[item.firmado] || '');
    },
    getChipClass(item) {
      if (item.firmado === 'FIRMADO CONFORME') return ['according']
      if (item.firmado === 'FIRMADO DISCONFORME') return ['not-according']
      return ['locked']
    }
  }
}
</script>

<style scoped>
.outline-none {
  outline: none;
}

.documents--item:hover {
  background-color: #f5f5f5;
}

.documents--item__selected {
  background: #e0e0e0;
}

.documents--item div div p:first-child {
  color: #2d2d2d;
}

.documents--item div div p:nth-child(2) {
  color: #707070;
}

.item--subtitle {
  color: #707070;
}

.zt-chip {
  width: 65px;
  height: 24px !important;
  padding: 6px !important;
  display: flex;
  justify-content: center;
  font-size: 0.7rem !important;
  text-transform: uppercase;
  margin: 0 !important;
}

.zt-chip.according {
  background-color: #e0f9f1 !important;
  color: #269976 !important;
  border-color: #269976 !important;
}

.zt-chip.not-according {
  width: 84px;
  background-color: #fffaf1 !important;
  color: #d39011 !important;
  border-color: #d39011 !important;
}

.zt-chip.locked {
  background-color: #ebebeb !important;
  color: #575757 !important;
  border-color: #575757 !important;
  width: 105px;
}
</style>
